import React, { } from 'react';
import Accordion from '../../shared/Accordion';
import { ResourceStrings } from '../../../ResourceStrings';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootState';
import { Dialog, OperationState } from '../../../store/appState';
import styled from 'styled-components/macro';
import * as Actions from '../../../store/actions';
import PostDetail from '../PostDetail';
import { App } from '../../../app';
import { useHistory, useLocation } from 'react-router-dom';
import { forMinWidth } from '../../../theme/breakpoints';
import { RootPost } from '../../../RootPost';
import { DeflectInfo } from './SubmitPostView';
import { SearchResult } from '../../../SearchResults';

export interface SearchResultsAIProps {
    deflectInfo: DeflectInfo,
    results: SearchResult[],
}

export default function SearchResultsAI(props: SearchResultsAIProps): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);
    const searchText = useSelector((state: RootState) => state.appState.problems.searchtext);
    const history = useHistory();
    const location = useLocation();
    const userId = useSelector((state: RootState) => state.appState.userVsid);

    const { results } = props;
    const totalMatches = state.problems.results.countsByType ? state.problems.results.countsByType.problem + state.problems.results.countsByType.idea : 0;

    const onJoinDiscussion = (post: RootPost): void => {
        // @TODO: Do we need this call to prepare anything for submission?
        // It is clearing up the selected values like syslogs, screenshot
        // @TODO: Change the legacy setDialog call with something which gel better with browser's back navigation
        // For now push a new url with unused param to have 'back' action bring it back to this page
        Actions.setDialog(Dialog.comment);

        const params = new URLSearchParams(location.search);
        params.set("dialog", "comment");
        history.push(`${history.location.pathname}?${params}`);
    };

    const onUpvote = (post: RootPost): void => {
        Actions.voteFor(post);
    };

    return <Wrapper>
        {results.map((item, i) => (
            <Accordion
                data-cy={`rap-search-results-list-${i}`}
                key={i}
                onExpandedToggle={(isExpanded) => {
                    if (isExpanded) {
                        Actions.initDetailsView(item);
                        Actions.loadTicket(item.answerHubId);
                        App.telemetry.deflect(props.deflectInfo, "expand_suggestion", {
                            "position": (i + 1).toString(),
                            "state": item.state,
                            "trackingId": item.trackingId ?? "",
                            "title": item.title ?? "",
                            "url": item.communityUrl ?? "",
                            "solution_count": item.solutionCount?.toString() ?? "",
                            "comment_count": item.commentCount?.toString() ?? "",
                        });
                    }
                }}
                expanderLocation="left"
                className="post-detail-accordion"
                title={<Title>
                    <span
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: App.EscapeHtmlRawDisplay(item.title) }}
                    />
                </Title>}
            >
                <PostDetail 
                    deflectInfo={props.deflectInfo}
                    post={item}
                    postV3={state.ticketsById[item.answerHubId]}
                    signInState={state.signInState}
                    userId={userId}
                    onJoinDiscussion={onJoinDiscussion}
                    onUpvote={onUpvote} />
            </Accordion>
        ))}
    </Wrapper>
}

const Wrapper = styled.div`
      .post-detail-accordion + .post-detail-accordion {
        border-top: solid 1px  var(--color-on-surface-lighter);
    }
`;

const Title = styled.div`
    display: flex;
    justify-content: space-between;

    .right-icon {
        margin-left: 2rem;
    }
`;

const LoadMore = styled.div`
    text-align: center;
    margin: 0.8rem 0;

    button {
        font-size: 1.4rem;
    }
`;